<template>
  <div class="home">
    知我探索
  </div>
</template>

<script>

export default {
}
</script>
<style lang="less" scoped>
.home {
  display: flex;
  width: 100%;
  height: 100vh;
  background: skyblue;
  justify-content: center;
  align-items: center;
  color:#fff;
}
</style>
